// @ts-nocheck
import React, { useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import BusinessHeader from "../components/BusinessHeader";
import Home from "../pages/Home";

// Home is the only page. Anything else (old cart / menu / order-status links,
// bookmarks, typos) lands back on it.
const Navigation = () => {
    const [activeSection, setActiveSection] = useState('menu');

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/home" element={
                    <>
                        <BusinessHeader
                            showMenu={true}
                            activeSection={activeSection}
                            setActiveSection={setActiveSection}
                        />
                        <Home />
                    </>
                } />
                <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
        </BrowserRouter>
    );
};

export default Navigation;
